const productConfiguratorHelper = {
    mergeQualities: function (qualities, prismicQualities) {
        if (prismicQualities.length === 0) {
            return qualities;
        }
        const result = [];
        for (const quality of qualities) {
            for (const prismicQuality of prismicQualities) {
                if (quality.id === prismicQuality.uuid) {
                    result.push({...quality, ...prismicQuality})
                }
            }
        }
        return result;
    },

    fullOptionKey: function (option) {
        if (option.dependsOn && option.dependsOn.length === 0) {
            return option.key;
        } else {
            return option.dependsOn.map((dependentOption) => productConfiguratorHelper.fullOptionKey(dependentOption)).join('+') + '-' + option.key;
        }
    },

    getEquivalentVariantOptionKey: function (variant, key) {
        if (!key) {
            return productConfiguratorHelper.getDefaultVariantOptionKey(variant);
        }
        if (variant.options.some((variant) => variant.key === key)) {
            return key;
        }
        let searchKey = key.split(/\./).pop();
        let sepOption = variant.options.find((option) => option.key.split(/\./).pop() === searchKey);
        if (sepOption != null) {
            return sepOption.key;
        }
        let endsWithOption = variant.options.find((option) => option.key.endsWith(searchKey));
        if (endsWithOption != null) {
            return endsWithOption.key;
        }
        return productConfiguratorHelper.getDefaultVariantOptionKey(variant);
    },

    getDefaultVariantOptionKey: function (variant) {
        let defaultOption = variant.options.find((option) => option.default);
        if (defaultOption != null) {
            return defaultOption.key;
        }
        return variant.options[0].key;
    },

    pricingKey: function (pricingRequest) {
        return JSON.stringify(pricingRequest);
    },

    openLink: function (url) {
        if (url) {
            location.href = url;
        }
    },

    preSelectDuration: function (allQueryParam) {
        // Query Params
        let durationQueryParam = allQueryParam.duration;
        let durationTimeUnitQueryParam = allQueryParam.duration_time_unit;

        // Duration
        if (durationQueryParam) {
            let durationType = document.getElementById(durationQueryParam.toUpperCase());
            if (durationQueryParam === 'YEARS') {
                if (durationTimeUnitQueryParam !== '1') {
                    durationType = document.getElementById(durationQueryParam.toUpperCase() + durationTimeUnitQueryParam)
                    if (durationType) {
                        setTimeout(function () {
                            durationType.click();
                        }, 100);
                    }
                } else {
                    if (durationType) {
                        durationType.click();
                    }
                }
            } else {
                if (durationType) {
                    durationType.click();
                }
            }
        }

        // Duration Time Unit
        let durationTimeUnit = document.getElementById('duration-time-' + durationTimeUnitQueryParam);
        let durationTimeUnitSelect = document.getElementById("duration-time-unit");
        if (durationTimeUnitQueryParam && durationTimeUnit && durationQueryParam.toUpperCase() === "DAYS") {
            durationTimeUnit.selected = true;
            durationTimeUnitSelect.dispatchEvent(new Event('change'));
        }
    },
};

export default productConfiguratorHelper;
